__turbopack_context__.v({
  "cardAsset": "Hgethq_cardAsset",
  "cardImage": "Hgethq_cardImage",
  "cardSubtitle": "Hgethq_cardSubtitle",
  "cardText": "Hgethq_cardText",
  "cardTitle": "Hgethq_cardTitle",
  "container": "Hgethq_container",
  "darkCard": "Hgethq_darkCard",
  "grid": "Hgethq_grid",
  "h2White": "Hgethq_h2White",
  "root": "Hgethq_root" + " " + __turbopack_context__.i(46473)["sectionPadding"],
  "textContent": "Hgethq_textContent",
});
